(function () {
  var root = document.querySelector('[data-sova-cart]');
  if (!root) return;

  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;

  function money(cents) {
    if (window.SovaMoney) return window.SovaMoney.format(cents, moneyFormat);
    return (cents / 100).toFixed(2);
  }

  function lineIndex(item) {
    return parseInt(item.getAttribute('data-sova-line'), 10);
  }

  function setBusy(item, busy) {
    item.classList.toggle('is-updating', busy);
  }

  function refreshShipping(totalPrice) {
    var wrap = root.querySelector('[data-sova-ship]');
    if (!wrap || !threshold) return;

    var fill = wrap.querySelector('[data-sova-ship-fill]');
    var text = wrap.querySelector('[data-sova-ship-text]');
    var remaining = threshold - totalPrice;
    var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));

    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.toggle('is-complete', remaining <= 0);
    }

    var track = wrap.querySelector('.sova-ship-track');
    if (track) track.setAttribute('aria-valuenow', pct);

    if (text) {
      if (remaining > 0) {
        text.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>' +
          '<span>You\'re <strong>' + money(remaining) + '</strong> away from free shipping</span>';
      } else {
        text.innerHTML =
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
          '<span><strong>You\'ve unlocked free shipping</strong></span>';
      }
    }

    var shipLabel = root.querySelector('[data-sova-ship-label]');
    if (shipLabel) shipLabel.textContent = remaining <= 0 ? 'Free' : 'Calculated at checkout';
  }

  function refreshTotals(cart) {
    var sub = root.querySelector('[data-sova-subtotal]');
    var total = root.querySelector('[data-sova-total]');
    if (sub) sub.textContent = money(cart.total_price);
    if (total) total.textContent = money(cart.total_price);
    refreshShipping(cart.total_price);

    var badge = document.querySelector('.sova-cart-count');
    if (badge) badge.textContent = cart.item_count;
  }

  function updateLine(item, quantity) {
    setBusy(item, true);

    var changeUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/change.js';

    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: lineIndex(item), quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (quantity === 0) {
          window.location.reload();
          return;
        }

        var line = cart.items[lineIndex(item) - 1];
        if (!line) {
          window.location.reload();
          return;
        }

        var lineTotal = item.querySelector('.sova-cart-line-total');
        if (lineTotal) lineTotal.textContent = money(line.final_line_price);

        var each = item.querySelector('.sova-cart-each');
        if (each) {
          each.textContent = line.quantity > 1 ? money(line.final_price) + ' each' : '';
        }

        var input = item.querySelector('[data-sova-qty-input]');
        if (input) input.value = line.quantity;

        refreshTotals(cart);
        setBusy(item, false);
      })
      .catch(function () {
        setBusy(item, false);
        window.location.reload();
      });
  }

  root.querySelectorAll('.sova-cart-item').forEach(function (item) {
    var input = item.querySelector('[data-sova-qty-input]');
    var up = item.querySelector('[data-sova-qty-up]');
    var down = item.querySelector('[data-sova-qty-down]');
    var remove = item.querySelector('[data-sova-remove]');

    if (up) up.addEventListener('click', function () {
      updateLine(item, (parseInt(input.value, 10) || 1) + 1);
    });

    if (down) down.addEventListener('click', function () {
      var next = (parseInt(input.value, 10) || 1) - 1;
      updateLine(item, Math.max(0, next));
    });

    if (input) input.addEventListener('change', function () {
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 1;
      updateLine(item, val);
    });

    if (remove) remove.addEventListener('click', function () {
      updateLine(item, 0);
    });
  });
})();
